import React from 'react';
import './styles.scss';
import WofButton from '../WofButton';
const Faqs: React.FC<any> = ({ title,titleColor,subheading,subheadingColor,backgroundImage,ctaText,ctaLink,questionAnswers,ctabaseColor,ctahoverColor, faqClass, faqQuestionColor, faqQuestionDesktopfontsize, faqQuestionMobilefontsize, faqAnsDesktopfontsize, faqAnsMobilefontsize, faqAnswerColor }) => {
  return (
    <div className={"faq "+faqClass} style={{ backgroundImage: `url(${backgroundImage})` }}>
		{<style dangerouslySetInnerHTML={{__html: `.wof-react-component .wrapper .question p {
        color: `+faqQuestionColor+`;
        font-size: `+faqQuestionDesktopfontsize+`px;
      }
      .wof-react-component .wrapper .answer p {
        color: `+faqAnswerColor+`;
        font-size: `+faqAnsDesktopfontsize+`px;
      }
      @media (min-width: 320px) and (max-width: 767px) {
        .wof-react-component .wrapper .question p {
        font-size: `+faqQuestionMobilefontsize+`px;
      }
      .wof-react-component .wrapper .answer p {
        font-size: `+faqAnsMobilefontsize+`px;
      }` }} /> }
    <div className="container">
      <div className="row">
       <div className="col-12 col-lg-10 offset-lg-1">
        <div className="col-md-12">
          <div className="faq-title" style={{ color:titleColor }} > { title } </div>
          <div className="faq-subheading" style={{color: subheadingColor}} dangerouslySetInnerHTML={{__html: subheading}}/>
         {(questionAnswers as any[]).map(
            ({ question, answer }, i) => (
             <div key={`faq-${i}`} className={"wrapper col-xs-12"}>
                <div className="question"  dangerouslySetInnerHTML={{__html: question}}/>

                <div className="answer" dangerouslySetInnerHTML={{__html: answer}}/>
             </div>
         ),
        )}
           {ctaText ?  <WofButton baseColor={ctabaseColor} hoverColor ={ctahoverColor} href={ctaLink}>{ctaText}</WofButton> : null}
        </div>
      </div>
      </div>
      </div>
    </div>
  );
};

export default Faqs;

// <a href={ctaLink} className="back-to-home">{ctaText}</a>